import type { z } from 'zod'

import { CreateGuarantorFormSchema } from './create-guarantor'

export const UpdateGuarantorSchema = CreateGuarantorFormSchema.partial()

export type UpdateGuarantorSchema = z.infer<typeof UpdateGuarantorSchema>
